import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PhieuXuatKhoVatTuTableColumns from "./PhieuXuatKhoVatTuTableColumns.vue";
import type { PhieuXuatKhoTableColumnId } from "./composables/usePhieuXuatKhoTableColumns";
import type { PhieuXuatKhoTableRow } from "./types";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhieuXuatKhoVatTuTableShell',
  props: {
    data: {},
    visibleColumns: {},
    enableFooter: { type: Boolean, default: false },
    emptyText: { default: "" },
    footerRowClassName: {},
    footerSpanMethod: {},
    cellClassName: {},
    scrollbarAlwaysOn: { type: Boolean, default: false },
    size: { default: "default" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    class: "phieu-xuat-kho-vat-tu-table",
    border: true,
    "cell-class-name": _ctx.cellClassName,
    data: _ctx.data,
    "empty-text": _ctx.emptyText,
    "row-class-name": _ctx.enableFooter ? _ctx.footerRowClassName : undefined,
    "scrollbar-always-on": _ctx.scrollbarAlwaysOn,
    size: _ctx.size,
    "span-method": _ctx.enableFooter ? _ctx.footerSpanMethod : undefined,
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(PhieuXuatKhoVatTuTableColumns, { "visible-columns": _ctx.visibleColumns }, null, 8, ["visible-columns"])
    ]),
    _: 1
  }, 8, ["cell-class-name", "data", "empty-text", "row-class-name", "scrollbar-always-on", "size", "span-method"]))
}
}

})